import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { Category, getCategories } from '@/services/categories'

export const useCategories = (
  options?: Omit<UseQueryOptions<Category[]>, 'queryKey'>
) =>
  useQuery({
    queryKey: ['categories'],
    queryFn: () => getCategories(),
    ...options,
  })

export const useSurveyCategories = (
  options?: Omit<UseQueryOptions<Category[]>, 'queryKey'>
) =>
  useQuery({
    queryKey: ['surveyCategories'],
    queryFn: () => getCategories(true),
    ...options,
  })
